import ITrackingDetails from '../models/tracking-details.interface';
import ProductType from '../enum/product-type.enum';
import ABCStatuses from '../enum/ABC-outbound-status.enum';
import ABCA2AStatuses from '../enum/ABC-A2A-status.enum';
import SDSOutboundStatuses from '../enum/SDS-outbound-status.enum';
import SDSInboundStatuses from '../enum/SDS-inbound-status.enum';
import SDSA2AOutboundStatuses from '../enum/SDS-A2A-outbound-status.enum';
import SDSA2AInboundStatuses from '../enum/SDS-A2A-inbound-status.enum';

export default class BookingProductService {

  public trackingDetails: ITrackingDetails = null;
  public collectionSlot: string = null;

  constructor(trackingDetails: ITrackingDetails, collectionSlot: string) {
    this.trackingDetails = trackingDetails;
    this.collectionSlot = collectionSlot;
  }

  returnProductDetails() {

    let returnVal = null;

    try {

      let isABC = true;
      if (this.trackingDetails.addOnProductType.length === 0) {
        isABC = false;
      }

      if (isABC) {
        if (this.trackingDetails.journeyDirection === 1) {
          returnVal = !this.trackingDetails.isAirportToAirport ? ProductType['ABC Outbound'] : ProductType['ABC Outbound A2A'];
        } else if (this.trackingDetails.journeyDirection === 2) {
          returnVal = !this.trackingDetails.isAirportToAirport ? ProductType['ABC Inbound'] : ProductType['ABC Inbound A2A'];
        }
      } else {
        if (this.trackingDetails.journeyDirection === 1) {
          returnVal = !this.trackingDetails.isAirportToAirport ? ProductType['SDS Outbound'] : ProductType['SDS Outbound A2A'];
        } else if (this.trackingDetails.journeyDirection === 2) {
          returnVal = !this.trackingDetails.isAirportToAirport ? ProductType['SDS Inbound'] : ProductType['SDS Inbound A2A'];
        }
      }

    } catch (error) {
      console.log('add on product is null');
      returnVal = 1;
    }

    return returnVal === null ? 1 : returnVal;

  }

  returnProductString(product: number) {
    return ProductType[product];
  }

  returnStatusString(product: number, statusBE: number) {
    let status = statusBE;

    // if product is SDS Inbound, map to correct status
    if (product === 4 || product === 8) {
      if (statusBE === 1 && this.collectionSlot === null) {
        status = 3;
      } else if (statusBE === 3) {
        status = 2;
      }
    }

    switch (product) {
      case 1:
        return ABCStatuses[status];
      case 2:
        return ABCStatuses[status];
      case 3:
        return SDSOutboundStatuses[status];
      case 4:
        return SDSInboundStatuses[status];
      case 5:
        return ABCA2AStatuses[status];
      case 6:
        return ABCA2AStatuses[status];
      case 7:
        return SDSA2AOutboundStatuses[status];
      case 8:
        return SDSA2AInboundStatuses[status];
      default:
        return ABCStatuses[status];
    }

  }

};



// WEBPACK FOOTER //
// ./src/services/booking-product.service.tsx